export default __webpack_public_path__ + "static/media/customer.0fe2347e.png";